import { Anchor } from '@mantine/core';

interface ExternalSourceLinkProps {
  url: string;
  name: string;
}
export function ExternalSourceLink({ url, name }: ExternalSourceLinkProps) {
  return (
    <Anchor
      target="_blank"
      href={url}
    >
      {name}
    </Anchor>
  );
}
